import FormattedMessage from 'I18n/components/FormattedMessage';
import ViewCertificateModal from 'academy-common-lib/features/certificate/components/ViewCertificateModal';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewAwardButton = ({
  grantedCredentialId,
  trackId,
  showShareButton = false,
  onClick = () => {},
  onDownloadCertificateClick = () => {}
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => {
        setIsOpen(true);
        onClick();
      },
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.certificationProfile.table.viewAward"
      })
    }), isOpen && /*#__PURE__*/_jsx(ViewCertificateModal, {
      grantedCredentialId: grantedCredentialId,
      onCloseClick: () => setIsOpen(false),
      onDownloadCertificateClick: onDownloadCertificateClick,
      showShareButton: showShareButton,
      trackId: trackId
    })]
  });
};
export default ViewAwardButton;